import CrudRepository from './CrudRepository'
export default class UserNameRepository extends CrudRepository {
  constructor () {
    super('core/api/users/profile')
  }
}
